import LegalLayout, { COMPANY, EMAIL } from "./LegalLayout";

export default function DataDeletion() {
  return (
    <LegalLayout title="Eliminación de datos">
      <p>En {COMPANY} respetamos tu derecho a eliminar tus datos. Esta página explica cómo solicitar la eliminación de tu cuenta y de la información asociada, conforme a los requisitos de Google, Wix, Shopify y las leyes de protección de datos aplicables.</p>

      <h2>Qué se elimina</h2>
      <ul>
        <li>Tu cuenta y perfil (nombre, correo, negocio).</li>
        <li>Tus productos, logos, colecciones, categorías y diseños.</li>
        <li>Tokens de integración (Wix, Shopify, Google) y su revocación.</li>
        <li>Registros de comisiones y datos asociados (salvo lo que la ley exija conservar por motivos fiscales/contables).</li>
      </ul>

      <h2>Cómo solicitar la eliminación</h2>
      <ol className="list-decimal pl-6 space-y-1">
        <li><b>Desde la app:</b> pide a tu administrador de plataforma la eliminación de tu cuenta, o desconecta tus integraciones en Ajustes.</li>
        <li><b>Por correo:</b> escribe a <a href={`mailto:${EMAIL}?subject=Solicitud%20de%20eliminaci%C3%B3n%20de%20datos`}>{EMAIL}</a> desde el correo de tu cuenta con el asunto "Solicitud de eliminación de datos".</li>
      </ol>
      <p>Procesaremos tu solicitud en un plazo máximo de 30 días y te confirmaremos por correo cuando se complete.</p>

      <h2>Datos de Google</h2>
      <p>Si conectaste tu cuenta de Google, puedes revocar el acceso en cualquier momento en <a href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer">myaccount.google.com/permissions</a>. Al desconectar Gmail en Ajustes, revocamos el token y eliminamos las credenciales almacenadas.</p>

      <h2>Contacto</h2>
      <p>{COMPANY} — <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>
    </LegalLayout>
  );
}
